// TODO: remove/refactor this component in https://disco-team.atlassian.net/browse/DISCO-7288 */
import 'pages/e2/e2.prototype.css'
import React from 'react'
import { useSelector } from 'hooks/use-redux'
import { getTextColor } from '@disco/utils/colors'
type Props = {
  firstName: string | null | undefined
  lastName: string | null | undefined
  email: string | null | undefined
}
export const E2Avatar = (props: Props): React.ReactNode => {
  const isCurrent = useSelector(state => state.user.email === props.email)
  const email = props.email || '-' // needs real name

  const initials =
    props.firstName && props.lastName
      ? props.firstName[0] + props.lastName[0]
      : email.slice(0, 2).toUpperCase()
  const avatarBg = getTextColor(initials)
  const name =
    props.firstName && props.lastName
      ? `${props.firstName} ${props.lastName}`
      : email
  return (
    <div
      className="e2avatar"
      style={
        isCurrent
          ? null
          : {
              background: avatarBg,
              color: '#fff',
            }
      }
      title={name}
    >
      {initials}
    </div>
  )
}
